import { useHistory } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import Select from 'react-select';
import AutoComplete from "../../AutoComplete";
import SimpleReactValidator from "simple-react-validator";
import "react-phone-input-2/lib/style.css";
import EnquiryService from "../../../Services/EnquiryService";
import { productServices } from "../../../Services/index";
import Loader from "../../../Components/Loader";
import { DeleteItem } from "../../../Components/Modal";
import ShipmentDetail from "./ShipmentDetail";
import EnquiryHelper from "./EnquiryHelper";
import { toast } from "react-toastify";
import JobService from "../../../Services/JobService";
import { retailerService } from "../../../Services";
import getRandomkeys from "../../../Components/StringGenerator";
import GeneralCustomer from "./GeneralCustomer"
import TableService from "./TableService"
import DetailEnquiry from "./DetailEnquiry"
import EnquiryAddOns from "./EnquiryAddOns"
import Retailer from "./Retailer"
import Referral from "./Referral"
import masterServices from "../../../Services/masterService";
import { customerServiceService } from "../../../Services/index";
import { Form } from "react-bootstrap-v5";
const customer_Type = [
  { value: "TOURIST", label: "Tourist" },
  { value: "RESIDENT", label: "Resident" },
  { value: "OVERSEASCUSTOMER", label: "Overseas shoppers" },
];

export const EditEnquiry = () => {
  const history = useHistory();
  // const { id } = useParams()

  const id = history.location.state;
  const [productModal,setProductModal] = useState({open:false,data:null,index:0})
  const [, setForceUpdate] = useState("");
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  // const todayDate = new Date();
  // let date = JSON.stringify(todayDate);
  // date = date.slice(1, 11);

  const sType = {
    quote_air: '',
    quote_sea: '',
    quote_courier: '',
    quote_land: ''
  }

  const [quotationData, setQuotationData] = useState(sType)
  const [userFreight, setUserFreight] = useState(0);
  const [selectedValue, setSelectedValue] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [retailerListData, setRetailerListData] = useState([])
  const [spinner, setSpinner] = useState(false);
  const initial1 =  {item_id: '',type:"enter",
        item_description: "",
        no_of_pkgs: "",
        dimension: {
          kilogram: "",
          length: "",
          width: "",
          height: "",
        },
        total_volume_CBM: "",
        total_weight_KG: "",
        item_token: EnquiryHelper.stringGenerator(24),};
  const [productItemForArray, setProductItemForArray] = useState([initial1]);
  const [OrginValue, setOrginValue] = useState({
    city: '',
    country: '',
    country_short_name: '',
    latitude: '',
    longitude: '',
  });
  const [DestinationValue, setDestinationValue] = useState({
    city: '',
    country: '',
    country_short_name: '',
    latitude: '',
    longitude: '',
  });
  const [Keyword, setKeyword] = useState(null);
  const [finalFreightAmount, setFinalFreightAmount] = useState();
  const [productItem, setProductItem] = useState([]);
  const [goodValue, setGoodValue] = useState('');
  const [itemValue, setItemValue] = useState([]);
  // eslint-disable-next-line
  const [salesperson, setSalesperson] = useState();
  /// state for delivery
  const [deliverytype, setDeliverytype] = useState();
  const [deliverytotal, setDeliverTotal] = useState();
  const [deliveryInitial, setDeliveryInitial] = useState();
  /// state for insurance calculation
  const [insuranceValue, setInsuranceValue] = useState({
    items_goods: 0,
    insurance_premium: 0,
    minimum_aed: 0,
    insurance_amount: 0,
  });

  /// state for storage calcultation
  const [storageValue, setStorageValue] = useState({
    storage_value: 0,
    storage_charges: 0,
    handling_in: 0,
    handling_out: 0,
    minimum: 0,
    storage_amount: 0,
  });

  /// state for packing
  // eslint-disable-next-line
  const [totalpackingCharge, setTotalpackingCharge] = useState(0);
  const [packingJson, setPackingJson] = useState([]);
  const [packingChargeAmount, setPackingChargeAmount] = useState(0)
  // eslint-disable-next-line
  const [freightCharge, setFreightCharge] = useState(0)
  const [insuranceData, setInsuranceData] = useState()

  // state for token
  const [discountAmount, setDiscountAmount] = useState(0);
  const [percentageValue, setPercentageValue] = useState(0);
  const [followUpdate, setFollowupdate] = useState("");
  const [confirmedThis, setConfirmedthis] = useState();
  // eslint-disable-next-line
  const [isAddOnsShow, setIsAddOnsShow] = useState(false)
  const [quotedData, setQuotedData] = useState();
  const [portEntry, setPortEntry] = useState();
  const [serviceObj, setServiceObj] = useState();
  const [generalDetailsObj, setGeneralDetailsObj] = useState({
    retailer_name: '',
    retailer_id: "",
    referral_code: '',
    sales_person: "",
    promo_code: "",
    customer_service: "",
    customer_name: "",
  });

  const [deliverer, setDeliverer] = useState("RETAILER");
  /// loading state 
  const [loader, setLoader] = useState({
    air_loader: false,
    sea_loader: false,
    courier_loader: false,
    land_loader: false,
  })
  const [Phonenumber, setPhonenumber] = useState('');
  const [Codenumber, setCodenumber] = useState('');
  const [usertype, setUsertype] = useState({ value: '', label: '' });
  const [email, setEmail] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [validateFlag, setValidateFlag] = useState({
    requote: false,
    savetofollow: false,
    proceedjob: false
  })
  const [subTotalInit, setSubTotalInit] = useState()
  const [getDetailsData, setGetDetailsData] = useState()
  const [packingwithService, setPackingwithService] = useState();
  const [customerServiceList, setCustomerServiceList] = useState([]);
  ////// all state above


  useEffect(() => {
    getItemList();
    // eslint-disable-next-line
  }, []);


  const getItemList = () => {
    let param = {role : "customer_service"} 
    customerServiceService.getCustomerService(param).then((res) => {
      if (res.status) {
        let arr = []
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].employee_name){
            arr.push({
              ...res.data[i],
              value: res.data[i]?.employee_name,
              label: res.data[i]?.employee_name,
            });
          }
        }
        setCustomerServiceList(arr);
      }
    });
  };


  useEffect(() => {
    getRetalerItemList()
    getParticularEnquiry();
    // eslint-disable-next-line
  }, [])


  let quoteArrayData;
  // let arrayQuoteddata;
  const getParticularEnquiry = () => {
    EnquiryService.getEnquiryapiById(id).then((response) => {
      if (response.status === true) {
        if (response?.data && response.data.length && response.data[0]?.quotes.length) {
          let getDetails = response.data[0]?.quotes[0];
          // console.log(getDetails,'getDetails')
          setGetDetailsData(getDetails);
          if (Object.keys(getDetails?.referral_token_details).length > 0) {
            setGeneralDetailsObj({
              ...generalDetailsObj,
              customer_service: getDetails?.referral_token_details?.customer_service,
              referral_code: getDetails.referral_token_details.referral_token || getDetails.referral_token_details.referral_code,
              retailer_name: getDetails?.referral_token_details?.retailer_name,
              retailer_id: getDetails?.referral_token_details?.retailer_id,
              sales_person: getDetails.referral_token_details.contact_name,
            });
          }
          if (Object.keys(getDetails?.promo_code_details).length > 0) {
            setGeneralDetailsObj({
              ...generalDetailsObj,
              customer_service: getDetails?.promo_code_details?.customer_service,
              referral_code: getDetails.promo_code_details.promo_code || getDetails.referral_token_details.promo_code,
              promo_code: getDetails.promo_code_details.promo_code || getDetails.referral_token_details.promo_code,
              retailer_id: getDetails?.promo_code_details?.retailer_id,
              retailer_name: getDetails?.promo_code_details?.retailer_name,
              sales_person: getDetails.promo_code_details.contact_name,
            });
          }
          // to add percentage of promo also 
          setPercentageValue(getDetails?.referral_token_details?.customer_discount 
            || getDetails?.promo_code_details?.customer_discount);
            // to add percentage of promo also 


          // setInsuranceValue({
          //   ...insuranceValue,
          //   items_goods: getDetails?.quote_request_items[0]?.insurance?.items_goods || 0,
          //   insurance_amount: getDetails?.quote_request_items[0]?.insurance?.insurance_amount || 0
          // })
          setStorageValue({
            ...storageValue,
            storage_value: getDetails?.quote_request_items[0]?.storage?.storage_value || 0,
            storage_amount: getDetails?.quote_request_items[0]?.storage?.storage_amount || 0
          })
          let getDeliverer = getDetails.quote_air.length>0 
                            ? getDetails.quote_air[0].request_data?.deliverer 
                            : getDetails.quote_sea.length >0
                            ? getDetails.quote_sea[0].request_data?.deliverer
                            : getDetails.quote_land.length >0
                            ? getDetails.quote_land[0].request_data?.deliverer
                            : ""
          setDeliverer(getDeliverer)
          setPhonenumber(getDetails.user_detail.user_phone_number);
          setCodenumber(getDetails.user_detail.user_dial_code);
          setUsertype({ value: getDetails.user_detail.user_type, label: getDetails.user_detail.user_type });
          setEmail(getDetails.user_detail.user_email);
          setCustomerName(getDetails.user_detail.user_full_name);
          setSelectedValue(getDetails?.selected_courier_type === "NONE" ? "" : getDetails?.selected_courier_type);
          // setGoodValue(getDetails?.quote_request_items[0]?.insurance?.insurance_amount || 0);


          let sTypeObject = Object.keys(sType);
          for (let key of sTypeObject) {
            if (getDetails[key].length > 0 && getDetails[key][0]?.request_data) {
              quoteArrayData = getDetails[key][0]?.request_data
              console.log("quoteArrayData ...", getDetails[key][0]?.request_data)
            }
          }
          if (quoteArrayData) {
            setIsAddOnsShow(true);
            // setInsuranceValue({
            //   ...insuranceValue,
            //   items_goods: quoteArrayData?.items_goods || 0,
            //   insurance_amount: getDetails?.quote_request_items[0]?.insurance?.insurance_amount || 0
            // })
            getInsuranceList(quoteArrayData?.items_goods, getDetails?.quote_request_items[0]?.insurance?.insurance_amount)
            setGoodValue(quoteArrayData?.items_goods || 0);
            setOrginValue({
              city: quoteArrayData.origin_city,
              country: quoteArrayData.origin_country,
              country_short_name: quoteArrayData.origin_country_short_name,
              latitude: quoteArrayData.origin_latitude,
              longitude: quoteArrayData.origin_longitude,
            });
            setDestinationValue({
              city: quoteArrayData.destination_city,
              country: quoteArrayData.destination_country,
              country_short_name: quoteArrayData.destination_country_short_name,
              latitude: quoteArrayData.destination_latitude,
              longitude: quoteArrayData.destination_longitude,
            });
            let quoteObj = {
              quote_air: getDetails.quote_air,
              quote_sea: getDetails.quote_sea,
              quote_courier: getDetails.quote_courier,
              quote_land: getDetails.quote_land,
              request_data: quoteArrayData
            }
            setQuotationData(quoteObj)
            let selServiceType = getDetails?.selected_courier_type === "NONE" ? "" : getDetails?.selected_courier_type
            let getfreight = EnquiryHelper.getAmountFreight(selServiceType, quoteObj);
            EnquiryHelper.getAmountFreight(selServiceType, quoteObj);
            let serviceObject = EnquiryHelper.getService(quoteObj);
            setServiceObj(serviceObject);
            setDeliveryInitial(getfreight?.withoutDiscount);

            let prodArry = [];
            let prodArry1 = [];
            quoteArrayData?.items.length > 0 && quoteArrayData.items.map((val) => {
                prodArry.push({
                  ...val,
                  PD: val.item_description,
                  PC: val.no_of_pkgs,
                  KG: val.dimension.kilogram,
                  LN: val.dimension.length,
                  WI: val.dimension.width,
                  HI: val.dimension.height,
                  CBM: val.total_volume_CBM,
                  TKG: val.total_weight_KG,
                });
              });
            quoteArrayData?.items.length > 0 && quoteArrayData.items.map((val) => {
                prodArry1.push({
                  ...val,
                  type : val?.item_id ? "select" : "enter"
                });
              });
              // setProductList(prodArry);
              setProductItemForArray(prodArry1)

            let addOnsPacking = getDetails?.quote_request_items[0]?.add_ons_items

            let addOnshere = [],
              fcharge = [];
            quoteArrayData?.items.length &&
            // eslint-disable-next-line
              quoteArrayData.items.map((data, index) => {
                addOnshere.push({
                  dimension: {
                    kilogram: Number(data.dimension.kilogram),
                    length: Number(data.dimension.length),
                    width: Number(data.dimension.width),
                    height: Number(data.dimension.height),
                  },
                  after_packing_dimension: {
                    kilogram: Array.isArray(addOnsPacking) ? addOnsPacking[index]?.kilogram : addOnsPacking?.kilogram,
                    length: Array.isArray(addOnsPacking) ? addOnsPacking[index]?.length : addOnsPacking?.length,
                    width: Array.isArray(addOnsPacking) ? addOnsPacking[index]?.width : addOnsPacking?.width,
                    height: Array.isArray(addOnsPacking) ? addOnsPacking[index]?.height : addOnsPacking?.height,
                  },
                  item_description: data.item_description,
                  item_id: data.item_id,
                  no_of_pkgs: Number(data.no_of_pkgs),
                  total_volume_CBM: Number(data.total_volume_CBM),
                  total_weight_KG: Number(data.total_weight_KG),
                  after_packing_total_volume_CBM: Array.isArray(addOnsPacking) ? addOnsPacking[index]?.total_volume_CBM : addOnsPacking?.total_volume_CBM,
                  after_packing_total_weight_KG: Array.isArray(addOnsPacking) ? addOnsPacking[index]?.total_weight_KG : addOnsPacking?.total_weight_KG,
                  packing_type: Array.isArray(addOnsPacking) ? addOnsPacking[index]?.packing_type : addOnsPacking?.packing_type,
                  packing_charges: Array.isArray(addOnsPacking) ? addOnsPacking[index]?.packing_charges : addOnsPacking?.packing_charges,
                  freight_charges: Array.isArray(addOnsPacking) ? addOnsPacking[index]?.freight_charges : addOnsPacking?.freight_charges,
                  item_token: data.item_token,
                });
                fcharge.push(Array.isArray(addOnsPacking) ? addOnsPacking[index]?.freight_charges : addOnsPacking?.freight_charges);
              });

            let finalBalanceAmt = fcharge.reduce((a, b) => a + b);
            let ch =
              addOnshere &&
              addOnshere.reduce(
                (total, item) => Number(item.packing_charges) + total,
                0
              );

            let totalPackingCharge = +finalBalanceAmt + +ch;
            setPackingChargeAmount(totalPackingCharge);
            setPackingwithService(totalPackingCharge + +getfreight?.withoutDiscount)
                // condition for if  have insurance and promo
            let subTotaldata = +getDetails.quote_request_items[0]?.insurance?.insurance_amount || 0 +getDetails.quote_request_items[0]?.storage?.storage_amount || 0
            + (totalPackingCharge + +getfreight?.withoutDiscount) 
            let discountAmt = EnquiryHelper.getDiscountbyPercentage(getDetails?.referral_token_details?.customer_discount || 
              getDetails?.promo_code_details?.customer_discount, subTotaldata);
              // condition for if  have insurance and promo
            setDiscountAmount(discountAmt);
            setSubTotalInit(subTotaldata)
            let finalRateAmount = subTotaldata - discountAmt
            setFinalFreightAmount(finalRateAmount);
            setPackingJson(addOnshere);


            let key1, key2;
            for (let key in serviceObject) {
              if (selServiceType) {
                if (selServiceType.includes("PORT")) key2 = 'port_delivery'
                if (selServiceType.includes("DOOR")) key2 = 'door_delivery'
                if (selServiceType.includes("CONSOLIDATION")) key2 = 'consolidation_delivery'

                if (selServiceType.includes('AIR')) {
                  key1 = 'air'
                } else if (selServiceType.includes('COURIER')) {
                  key1 = 'courier'
                } else if (selServiceType.includes('SEA')) {
                  key1 = 'sea'
                } else if (selServiceType.includes('LAND')) {
                  key1 = 'land'
                }

                if (key1 !== undefined && key2 !== undefined) {
                  let cKey = `${key1}_${key2}`
                  if (key === cKey) {
                    //  deliveryHandler({target: {value: key2.key1}}, key2.key1, serviceObj[key])
                    setQuotedData(serviceObject[key])
                    setUserFreight(serviceObject[key])
                  }
                }
              }
            }

          }
        }
      }

    }).catch(error => {
      console.log(error);
    })


  }

  const getInsuranceList = (itemsGood, InsuranceAmt) => {
    masterServices.get_insurance().then((result) => {
      if (result.status === true) {
        // if (insuranceValue) insuranceValue.items_goods = itemGoods
        // if (insuranceValue) insuranceValue.insurance_amount = insuranceValue.insurance_amount
        setInsuranceData(result.data);
        setInsuranceValue({
          ...insuranceValue,
          items_goods: itemsGood,
          insurance_amount: InsuranceAmt,
          insurance_premium: result.data[0].insurance_premium,
          minimum_aed: result.data[0].minimum_aed,
        });
      }
    });
  };



  const onChangeEvent = (key, event,subkey) => {
    let { name, value } = event.target;
    let arry = [...productItemForArray];
    let obj = arry[key];
    
    if (name != 'kilogram' && name != 'item_description') {
      obj['total_volume_CBM'] = getCBM(obj, name, value);
    }
    
    if (name === 'kilogram' || name === 'no_of_pkgs') {
      obj['total_weight_KG'] = getTKg(obj, name, value);
    }
    
    if(subkey){
      obj[subkey][name] = value;
    }else{
      obj[name] = value;
    }
    arry.splice(key, 1, obj);
    setProductItemForArray(arry)
  };

  const getTKg = (obj, act, count) => {
    switch (act) {
      case 'kilogram':
        return obj.no_of_pkgs * count;
      case 'no_of_pkgs':
        return count * obj.dimension.kilogram;
    }
  };

  const getCBM = (obj, act, count) => {
    switch (act) {
      case 'no_of_pkgs':
        return (
          Number(count) *
          ((Number(obj.dimension.length) * Number(obj.dimension.width) * Number(obj.dimension.height)) / 1000000)
        ).toFixed(3);
      case 'length':
        return (
          Number(obj.no_of_pkgs) *
          ((Number(count) * Number(obj.dimension.width) * Number(obj.dimension.height)) / 1000000)
        ).toFixed(3);
      case 'width':
        return (
          Number(obj.no_of_pkgs) *
          ((Number(obj.dimension.length) * Number(count) * Number(obj.dimension.height)) / 1000000)
        ).toFixed(3);
      case 'height':
        return (
          Number(obj.no_of_pkgs) *
          ((Number(obj.dimension.length) * Number(obj.dimension.width) * Number(count)) / 1000000)
        ).toFixed(3);
    }
  };

  const addProductHandler = () => {
    let addArray = [...productItemForArray];
    addArray.push(initial1);
    setProductItemForArray(addArray);
  };

  const deleteProductHandler = (key,item) => {
    console.log(item,'item')
    let arr = [...productItemForArray]
    if(item.type==="select"){
      let filteredArr = arr.filter((itm)=> itm.item_description!==item.item_description)
      setProductItemForArray(filteredArr)
    }else{
      arr.splice(key,1)
      setProductItemForArray(arr)
    }

  };

  //// handlers for Google Map autoComplete
  const getOriginData = (e) => {
    if (e === "") {
      setOrginValue("");
    } else {
      let originData = {
        city: e.city,
        country: e.country,
        country_short_name: e.country_short_name,
        latitude: e.latitude,
        longitude: e.longitude,
      };
      setOrginValue(originData);
    }
  };

  const getDestinationData = (e) => {
    if (e === "") {
      setDestinationValue("");
    } else {
      let destinationData = {
        country: e.country,
        country_short_name: e.country_short_name,
        city: e.city,
        latitude: e.latitude,
        longitude: e.longitude,
      };
      setDestinationValue(destinationData);
    }
  };
  ///

  /// useeffect for product api call
  useEffect(() => {
    const timeOut = setTimeout(() => {
      getProductlist();
    }, 1000);
    return () => {
      clearTimeout(timeOut);
    };
  }, [Keyword]);

  //// function for ProductListapi calling
  const getProductlist = () => {
    let searchData = {
      search: Keyword,
    };
    productServices.getProduct(searchData).then((result) => {
      if (result.status === true) {
        let Productarray = result.data.map((item) => ({
          value: item._id,
          label: item.product_name,
          data: item,
        }));
        setProductItem(Productarray);
      }
    });
  };

  const searchHandler = (event) => {
    setItemValue(event.target.value);
    if (event.target.value.length >= 2) {
      setKeyword(event.target.value);
    }else{
      setKeyword("");
    }
  };

  const handleChange = (getvalue) => {
    setItemValue(getvalue);
    new_conditionFun(getvalue);
  };


  const addSelectedProduct = () => {
    // console.log(productModal.data,'productModal.data')
    let item = []
      let itemObj = productItem.find((item)=> item.label===productModal.data)
      let findItemObj = productItemForArray.find((item)=> item.item_description===productModal.data)
        if(findItemObj){
        }else{
          for (let i = 0; i < itemObj.data.product_dimentions.length; i++) {
            item.push({
              type : "select",
                item_id: itemObj.data._id,
                item_description: itemObj.data.product_name,
                no_of_pkgs: "1",
                dimension: {
                  kilogram: itemObj.data.product_dimentions[i].weight,
                  length:itemObj.data.product_dimentions[i].length,
                  width: itemObj.data.product_dimentions[i].width,
                  height: itemObj.data.product_dimentions[i].height,
                },
                total_volume_CBM: itemObj.data.product_gross_volume,
                total_weight_KG: itemObj.data.product_gross_weight,
            })
          }
        }
        let tempItem = productItemForArray
        tempItem.splice(productModal.index,1,...item)
        setProductItemForArray(tempItem)
    setProductModal({open:false,data:null,index:0})
    setProductItem([])
    setItemValue("")
    setKeyword("")
  }

  const new_conditionFun = (val) => {
    setProductModal({...productModal,data:val})
  };


  //////// EnquiryTab code start from here

  // for set user contact
  const setQuotesPhone = (event, g) => {
    if (g.target.value) {
      let num = g.target.value
        .split(" ")
        .slice(1)
        .join("")
        .replace(/[^a-zA-Z0-9]/g, "");
      let code = g.target.value.split(" ")[0];
      setPhonenumber(num);
      setCodenumber(code);
    }
  };
  const deliveryHandler = (e, type, quotedata) => {
    const { value } = e.target;
    // reset insurance,storage,packing onchange 
    setInsuranceValue({...insuranceValue, insurance_amount:''})
    setStorageValue ({...storageValue, storage_value:'',storage_amount:''})

    let datapacking = {...packingJson[0], freight_charges:0,packing_charges:0,packing_type:'none'}
   
    let postItem = {
      items: [datapacking],
      quote_token: quotationData?.request_data?.quote_token,
    };
    EnquiryService.updatePackingApi(postItem)
      .then((res) => {
        if (res.status === true) {
          setPackingJson([datapacking])
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
      setSubTotalInit(0)
      // reset insurance,storage,packing onchange 


    setPackingChargeAmount('')
    setSelectedValue(value);
    setDeliverTotal(quotedata);
    setDeliverytype(type);
    setDeliveryInitial(quotedata);
    setPackingwithService(quotedata + packingChargeAmount)
    setQuotedData(quotedata);
    if (quotedata.destination_air_rate) {
      setPortEntry(quotedata.destination_air_rate.port_of_entry);
    } else if (quotedata.destination_sea_rate) {
      setPortEntry(quotedata.destination_sea_rate.port_of_entry);
    } else if (quotedata.destination_courier_rate) {
      setPortEntry(quotedata.destination_courier_rate.port_of_entry);
    } else if (quotedata.destination_land_rate) {
      setPortEntry(quotedata.destination_land_rate.port_of_entry);
    }

    if (value && getDetailsData) {
      let param = {
        selected_courier_type: value,
        quote_token: getDetailsData.quote_token,
      };
      EnquiryService.postSelectedCourier(param).then((res) => {
        if (res.status === true) {
          // console.log(res.data);
        }
      });
    }
    // get data for promo code also using api
    if(generalDetailsObj.promo_code.length > 0){
      let postToken = {
        referral_token: generalDetailsObj?.promo_code,
      };
      retailerService.getRefferelRetailerData(postToken).then((res) => {
        if(res.status){
          let discountAmt = EnquiryHelper.getDiscountbyPercentage(res.data.customer_discount, quotedata);
              setDiscountAmount(discountAmt);
              setPercentageValue(res.data.customer_discount);
              // let subtotal = Number(quotedata) + Number(packingChargeAmount) 
              // + Number(insuranceValue.insurance_amount)
              // + Number(storageValue.storage_amount)
              // setSubTotalInit(subtotal)
              let finalAmount = Number(quotedata) - Number(discountAmt);
              setFinalFreightAmount(finalAmount);
        }
    })}
    else{      
          let postToken = {
            referral_token: generalDetailsObj?.referral_code
          };
          EnquiryService.productReferralCode(postToken).then((res) => {
            if (res.status === true) {
              let discountAmt = EnquiryHelper.getDiscountbyPercentage(res.data.customer_discount, quotedata);
              setDiscountAmount(discountAmt);
              setPercentageValue(res.data.customer_discount);
              // let subtotal = Number(quotedata) + Number(packingChargeAmount) + Number(insuranceValue.insurance_amount) + 
              // Number(storageValue.storage_amount)
              // setSubTotalInit(subtotal)
              let finalAmount = Number(quotedata) - Number(discountAmt);
              setFinalFreightAmount(finalAmount);
            }
          });
    }
    // get data for promo code also using api
  };

  const getRetalerItemList = () => {
    retailerService.getRetailer().then((res) => {
      if (res.status) {
        let listArry = [{ value: "none", label: "None" }];
        res.data.map((val) => {
          listArry.push({ value: val, label: val.retailer_name });
        });
        setRetailerListData(listArry);
      }
    });
  };

  ////
  useEffect(() => {

    if (quotationData.request_data?.general_details) {
      retailerListData && retailerListData.length > 0 &&
        retailerListData.map((element) => {
          if (element.label === quotationData.request_data.general_details.retailer_name) {
            setGeneralDetailsObj({
              ...generalDetailsObj,
              retailer_id: element.value._id,
              retailer_name: quotationData.request_data.general_details.retailer_name,
              referral_code: quotationData.request_data.general_details.referral_code,
              sales_person: quotationData.request_data.general_details.sales_person,
              promo_code: quotationData.request_data.general_details.promo_code,
              customer_service: quotationData.request_data.general_details.customer_service,
              customer_name: quotationData.request_data.general_details.customer_name,
            });
          }
        })

      setSalesperson(quotationData.request_data.general_details.sales_person);
    }
    if (quotationData?.request_data && quotationData.request_data.enquiry_details) {
      setFollowupdate(quotationData.request_data.enquiry_details.follow_up_date);
    }
    if (getDetailsData && getDetailsData.quote_status == "FOLLOWUP") {
      setConfirmedthis("YES");
    }
  }, [getDetailsData, retailerListData, quotationData?.request_data]);


  const reQuote = async () => {
    setValidateFlag({
      savetofollow: false,
      requote: true,
      proceedjob: false,
    })

    // let myitem;
    let myitem1;
    if (Array.isArray(quotationData.request_data?.items) && quotationData.request_data?.items.length) {
      const randomkeyString = EnquiryHelper.stringGenerator(24);
      myitem1 = productItemForArray?.length &&
      productItemForArray.map((val, i) => ({
          ...val,
          item_token: quotationData.request_data?.items[i] && quotationData.request_data?.items[i].item_token ? quotationData.request_data?.items[i].item_token : randomkeyString,
        }));
    }

    let random_key = getRandomkeys();
    let postData = {
      origin_country: OrginValue.country,
      origin_country_short_name: OrginValue.country_short_name,
      origin_city: OrginValue.city,
      origin_latitude: OrginValue.latitude,
      origin_longitude: OrginValue.longitude,
      destination_country: DestinationValue.country,
      destination_country_short_name: DestinationValue.country_short_name,
      destination_city: DestinationValue.city,
      destination_latitude: DestinationValue.latitude,
      destination_longitude: DestinationValue.longitude,
      number_of_packages: getGrandTotal()?.number_of_packages,
      volume: getGrandTotal()?.volume <= 0.000 ? 0.001 : parseFloat(getGrandTotal()?.volume),
      weight: getGrandTotal()?.weight,
      items_goods: Number(quotationData?.request_data?.items_goods),
      items: myitem1,
      user_id: getDetailsData && getDetailsData.user_id,
      quote_token: random_key,
      retailer_name: generalDetailsObj.retailer_name,
      referral_code: generalDetailsObj.referral_code,
      promo_code: generalDetailsObj.promo_code,
      sales_person: generalDetailsObj.sales_person,
      customer_service: generalDetailsObj.customer_service,
    };

    let ValidatedField = 0;

      ValidatedField = EnquiryHelper.validationRequoteFilter(validator, generalDetailsObj)


    if (ValidatedField) {
      setLoader({
        air_loader: true,
        sea_loader: true,
        courier_loader: true,
        land_loader: true,
      });
      let requoteApicall = await apiCallFunc(postData, "requote");
      if (
        (requoteApicall && requoteApicall.length && requoteApicall[0].status === true) &&
        (requoteApicall && requoteApicall.length && requoteApicall[1].status === true) &&
        (requoteApicall && requoteApicall.length && requoteApicall[2].status === true) &&
        (requoteApicall && requoteApicall.length && requoteApicall[3].status === true)
      ) {
        setLoader({
          air_loader: false,
          sea_loader: false,
          courier_loader: false,
          land_loader: false,
        })

        let quoteObj = {
          quote_air: [{ final: requoteApicall[1].data }],
          quote_sea: [{ final: requoteApicall[2].data }],
          quote_courier: [{ final: requoteApicall[0].data }],
          quote_land: [{ final: requoteApicall[3].data }],
          request_data: requoteApicall[0].request_data || requoteApicall[1].request_data || requoteApicall[2].request_data || requoteApicall[3].request_data
        }
        let serviceObject = EnquiryHelper.getService(quoteObj);
        setServiceObj(serviceObject);
        setQuotationData(quoteObj)
        setFinalFreightAmount();
        setDeliveryInitial();
        setSubTotalInit()
        setInsuranceValue({
          ...insuranceValue,
          insurance_amount: 0
        });
        setStorageValue({
          ...storageValue,
          storage_amount: 0
        });
        setPackingJson([]);
        setTotalpackingCharge();
        setPackingChargeAmount();
        setSelectedValue()
        // setDeliverTotal()
      }
    } else {
      validator.current.showMessages();
      toast.info("some field is missing, please check");
    }
  };

  const saveQuoteHandler = async (posttype) => {
    if (posttype === "confirmed") {
      setValidateFlag({
        savetofollow: false,
        requote: false,
        proceedjob: true,
      })
    } else {
      setValidateFlag({
        savetofollow: true,
        requote: false,
        proceedjob: false,
      })
    }

    let postData = null;
    let random_key = EnquiryHelper.stringGenerator(24);

    /// condition for productlist
    if (productItemForArray.length >= 1) {

      let knownData = productItemForArray.map((item, index) => ({
        ...item,
        item_token: item.item_token ? item.item_token : random_key,
      }));

      postData = {
        deliverer:deliverer,
        origin_country: OrginValue.country,
        origin_country_short_name: OrginValue.country_short_name,
        origin_city: OrginValue.city,
        origin_latitude: OrginValue.latitude,
        origin_longitude: OrginValue.longitude,
        destination_country: DestinationValue.country,
        destination_country_short_name: DestinationValue.country_short_name,
        destination_city: DestinationValue.city,
        destination_latitude: DestinationValue.latitude,
        destination_longitude: DestinationValue.longitude,
        number_of_packages: getGrandTotal()?.number_of_packages,
        volume: parseFloat(getGrandTotal()?.volume),
        weight: getGrandTotal()?.weight,
        items_goods: Number(goodValue),
        items: knownData,
        quote_token: getDetailsData && getDetailsData.quote_token,
        user_id: getDetailsData && getDetailsData.user_id,
        selected_courier_type: selectedValue,
      };
    }

    // code for referral token //sdm
    postData.referral_token = generalDetailsObj.referral_code ? generalDetailsObj.referral_code : ''
    //end
    let validate = 0;

      validate = EnquiryHelper.validationQuoteFilter(validator, generalDetailsObj)

    if (validate) {
      setLoader({
        air_loader: true,
        sea_loader: true,
        courier_loader: true,
        land_loader: true,
      });

      if (posttype === "confirmed") {
        let jobApiCall = await apiCallFunc(postData, "joblist");
        // proceedAddtojobHandler()
        if (
          (jobApiCall && jobApiCall.length && jobApiCall[0].status === true) &&
          (jobApiCall && jobApiCall.length && jobApiCall[1].status === true) &&
          (jobApiCall && jobApiCall.length && jobApiCall[2].status === true) &&
          (jobApiCall && jobApiCall.length && jobApiCall[3].status === true)
        ) {
          proceedAddtojobHandler()
        }

      } else if (posttype === "savetofollow") {
        if (!followUpdate) {
          setLoader({
            air_loader: false,
            sea_loader: false,
            courier_loader: false,
            land_loader: false,
          });
          toast.info("please select a date for Save Enquiry");
        } else {
          let resultData = await apiCallFunc(postData, "savetofollow");
          if (
            (resultData && resultData.length && resultData[0].status === true) &&
            (resultData && resultData.length && resultData[1].status === true) &&
            (resultData && resultData.length && resultData[2].status === true) &&
            (resultData && resultData.length && resultData[3].status === true)
          ) {
            let apiData = {
              quote_token: getDetailsData?.quote_token,
              insurance: insuranceValue,
              storage: storageValue
            }
            EnquiryService.saveToFollowUpAPi(apiData).then((response) => {
              if (response.status === true) {
                setQuotationData({
                  quote_air: [{ final: resultData[0].data }],
                  quote_sea: [{ final: resultData[1].data }],
                  quote_courier: [{ final: resultData[2].data }],
                  quote_land: [{ final: resultData[3].data }],
                  request_data: resultData[0].request_data || resultData[1].request_data || resultData[2].request_data || resultData[3].request_data
                })
                setLoader({
                  air_loader: false,
                  sea_loader: false,
                  courier_loader: false,
                  land_loader: false,
                });
                setInsuranceValue({
                  ...insuranceValue,
                  insurance_amount: 0
                });
                setStorageValue({
                  ...storageValue,
                  storage_amount: 0
                });
                setPackingJson([]);
                setTotalpackingCharge();
                setPackingChargeAmount();
                history.push("/follow-up");
              }
            }).catch(error => {
              console.log(error);
            })
          }
        }
      }
    } else {
      validator.current.showMessages();
      toast.info("some field is missing, please check");
    }
  };

  const apiCallFunc = async (collection, datatype) => {
    if (datatype == 'requote') {
      const quoteToken = await EnquiryService.getQuoteToken();
      collection.quote_token = quoteToken.data;
    }
    if (datatype == "savetofollow") {
      collection["enquiry_details"] = {
        follow_up_date: followUpdate,
      };
    }

    const courierReQuotedata = await EnquiryService.postCourierReQuote(collection);
    const airReQuotedata = await EnquiryService.postAirReQuote(collection);
    const seaReQuotedata = await EnquiryService.postSeaReQuote(collection);
    const landReQuotedata = await EnquiryService.postLandReQuote(collection);

    const promise1 = courierReQuotedata;
    const promise2 = airReQuotedata;
    const promise3 = seaReQuotedata;
    const promise4 = landReQuotedata;

    return Promise.all([promise1, promise2, promise3, promise4]).then((values) => {
      return values;
    });
  };
  const proceedAddtojobHandler = () => {
    let data = {
      customerName: customerName,
      email: email,
      Phonenumber: Codenumber + Phonenumber,
      usertype: usertype,
      OrginValue: OrginValue,
      DestinationValue: DestinationValue,
      goodValue: goodValue,
      deliverytype: deliverytype,
      selectedValue: selectedValue,
      quotedData: quotedData,
      actualAmount: subTotalInit,
      finalFreightAmount: finalFreightAmount,
      getDetails: getDetailsData,
      generalDetailsObj: generalDetailsObj,
      packingJson: packingJson,
      insuranceValue: insuranceValue,
      storageValue: storageValue,
      portEntry: portEntry,
      deliverytype: deliverytype,
      percentageValue: percentageValue,
      followUpdate: followUpdate,
      insurance: insuranceValue.insurance_amount || 0,
      storage: storageValue.storage_amount || 0,
      packingCharge: packingChargeAmount || 0,
      freight: deliveryInitial || 0,
      bookingAmount: finalFreightAmount || 0,
      quote_token: getDetailsData?.quote_token,
      discountAmount: discountAmount
    }

    let postedData = EnquiryHelper.proceedObject(data)
    let jobValid = EnquiryHelper.proceedValidation(validator, generalDetailsObj);

    let addedBy = {
      quote_by: 'ADMIN',
      quote_by_id: null,
      user_id: getDetailsData.user_id
    }

    if (getDetailsData.quote_by === "STORE") {
      addedBy.quote_by = "STORE"
      addedBy.quote_by_id = getDetailsData.quote_by_id
    } else if (getDetailsData.quote_by === "USER") {
      addedBy.quote_by = "USER"
      addedBy.quote_by_id = getDetailsData.referral_token_details.retailer_id
    }

    if (Object.keys(addedBy).length) {
      postedData.added_by = addedBy
    }

    if (jobValid) {
      setLoader({
        air_loader: true,
        sea_loader: true,
        courier_loader: true,
        land_loader: true,
      });
      JobService.addJobservice(postedData).then((res) => {
        if (res.status === true) {
          setLoader({
            air_loader: false,
            sea_loader: false,
            courier_loader: false,
            land_loader: false,
          });
          toast.success(res.message);
          history.push("/job-list")
        } else {
          toast.error(res.message);
        }
      });
    } else {
      validator.current.showMessages();
      toast.info("some field is missing, please check");
    }

  };

  const onModalSubmit = () => {
    let deleteData = {
      quote_token: quoteArrayData.quote_token,
    };

    EnquiryService.deleteEnquiry(deleteData).then((res) => {
      if (res.status === true) {
        toast.success("Deleted Successfully");
        history.push("/enquiry-management-c-r-m-list");
      } else {
        toast.error(res.message);
      }
    });
  };

  const getGrandTotal = () => {
    let arry = [...productItemForArray]
    let gTotal = {
      number_of_packages : 0,
      volume : 0,
      weight : 0,
    }
    for (let i = 0; i < arry.length; i++) {
      if(i>0 && arry[i-1].item_description===arry[i].item_description){
        }else{
          gTotal.number_of_packages +=(arry[i]?.no_of_pkgs ? Number(arry[i].no_of_pkgs) : 0)
          gTotal.volume +=(arry[i]?.total_volume_CBM ? Number(arry[i].total_volume_CBM) : 0)
          gTotal.weight +=(arry[i]?.total_weight_KG ? Number(arry[i].total_weight_KG) : 0)
        }
      }
    return {...gTotal,volume:gTotal.volume.toFixed(3)}
  }

  const handleCloseModal = () => {
    setItemValue("") 
    setProductItem([])
     setProductModal({open:false,data:null,index:0})
     setKeyword("")
  }


  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <section className="sectionBorder">
            <div className="card-header custom_header">
              <h5>Shipment Details</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label">Origin</label>
                  <AutoComplete
                    getData={(e) => getOriginData(e)}
                    prefillState={OrginValue && OrginValue}
                    value={OrginValue && OrginValue}
                  />
                  {validator.current.message("Origin", OrginValue, "required", {
                    className: "text-danger text-capitalize",
                  })}
                </div>
                <div className="mb-3 col-6">
                  <label className="form-label">Destination</label>
                  <AutoComplete
                    getData={(e) => getDestinationData(e)}
                    prefillState={DestinationValue && DestinationValue}
                    value={DestinationValue && DestinationValue}
                  />
                  {validator.current.message(
                    "Destination",
                    DestinationValue,
                    "required",
                    { className: "text-danger text-capitalize" }
                  )}
                </div>
              </div>
              <div className="row">
                <div className="position-relative me-2 mt-2">
                                <label className="form-label">Who will pickup</label>
                                <div key={`inline-radio`} className="mb-3">
                                    <Form.Check
                                        inline
                                        label="World2Door"
                                        name="deliverer"
                                        value="WORLD2DOOR"
                                        type="radio"
                                        id={`inline-radio-1`}
                                        checked={deliverer === 'WORLD2DOOR'}
                                        onChange={(e) => setDeliverer('WORLD2DOOR')}
                                    />
                                    <Form.Check
                                        inline
                                        label="Self"
                                        name="deliverer"
                                        value="SELF"
                                        type="radio"
                                        id={`inline-radio-2`}
                                        checked={deliverer === 'SELF'}
                                        onChange={(e) => setDeliverer('SELF')}
                                    />
                                    <Form.Check
                                        inline
                                        label="Retailer"
                                        name="deliverer"
                                        value="RETAILER"
                                        type="radio"
                                        id={`inline-radio-2`}
                                        checked={deliverer === 'RETAILER'}
                                        onChange={(e) => setDeliverer('RETAILER')}
                                    />

                                </div>
                            </div>
                </div>


              <ShipmentDetail
                addProduct={addProductHandler}
                onchangeHandler={onChangeEvent}
                deleteHandler={deleteProductHandler}
                setGood={setGoodValue}
                goodvalue={goodValue}
                itemProduct={productItem}
                valueItem={itemValue}
                productChange={handleChange}
                searchingHandler={searchHandler}
                validator={validator}
                productItemForArray={productItemForArray}
                addSelectedProduct={addSelectedProduct}
                productModal={productModal}
                setProductModal={setProductModal}
                getGrandTotal={getGrandTotal}
                handleCloseModal={handleCloseModal}
              />

            </div>
          </section>
          {/* <TabMenu /> */}

          {/* <div className="tab-content " id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="customerInfo"
              role="tabpanel"
            >
              
            </div> */}

          <section className="sectionBorder mt-3">
            <div className="card-header custom_header">
              <h5>Customer Details</h5>
            </div>

            <GeneralCustomer
              setName={setCustomerName}
              defaultvalue={customerName}
              setEmail={setEmail}
              email={email}
              setPhoneHandler={(a, b) => setQuotesPhone(a, b)}
              phone={Phonenumber}
              code={Codenumber}
              setUser={setUsertype}
              customerList={customer_Type}
              validator={validator}
              user={usertype}
              validateFlag={validateFlag}
            />

          </section>

          {/* <div className="tab-pane fade show" id="generalInfo" role="tabpanel">
             
            </div> */}

          <section className="sectionBorder mt-3">
            <div className="card-header custom_header">
              <h5>General Details</h5>
            </div>

            <div className="card-body">
              <div className="row">

                <Retailer
                  setDetail={setGeneralDetailsObj}
                  detail={generalDetailsObj}
                  setsales={setSalesperson}
                  setamount={setDiscountAmount}
                  totaldeliver={deliveryInitial}
                  setpercentvalue={setPercentageValue}
                  setFreight={setFinalFreightAmount}
                  totalFreightService={finalFreightAmount}
                  retailerList={retailerListData}
                />

                <Referral
                  setDetail={setGeneralDetailsObj}
                  detail={generalDetailsObj}
                  setamount={setDiscountAmount}
                  totaldeliver={deliveryInitial}
                  setFreight={setFinalFreightAmount}
                  validator={validator}
                  setpercentvalue={setPercentageValue}

                />

                <div className="mb-3 col-3">
                  <label className="form-label">Sales Person Name</label>
                  <input
                    className="form-control"
                    placeholder="Enter Sales Person Name "
                    value={generalDetailsObj.sales_person}
                    onChange={(e) => setGeneralDetailsObj({
                      ...generalDetailsObj,
                      sales_person: e.target.value
                    })}
                  />
                  {generalDetailsObj.retailer_name &&
                    generalDetailsObj.retailer_name != "None" &&
                    validator.current.message(
                      "Sales Person Name",
                      generalDetailsObj.sales_person,
                      "required",
                      { className: "text-danger text-capitalize" }
                    )}
                </div>

                <div className="mb-3 col-3">
                  <label className="form-label">Customer Service</label>
                  <Select
                      options={customerServiceList}
                      onChange={(e) =>
                        setGeneralDetailsObj({
                          ...generalDetailsObj,
                          customer_service: e?.employee_name,
                        })
                      }
                      value={customerServiceList.find((item) => {
                        return item?.employee_name === generalDetailsObj?.customer_service
                      })}
                    />

                  {/* <input
                    className="form-control"
                    type="email"
                    placeholder="Enter Customer Service Name"
                    onChange={(e) =>
                      setGeneralDetailsObj({
                        ...generalDetailsObj,
                        customer_service: e.target.value,
                      })
                    }
                    value={generalDetailsObj.customer_service}
                  /> */}
                  {validator.current.message(
                    "Customer Service",
                    generalDetailsObj.customer_service,
                    "required",
                    { className: "text-danger text-capitalize" }
                  )}
                </div>
              </div>
            </div>
          </section>

          {/* <div className="tab-pane fade show" id="quotationInfo" role="tabpanel">
             
            </div> */}

          <section className="mt-3 sectionBorder">
            <div className="row">
              <div className="col-12 pe-0 border-end">
                <div className="card-header custom_header">
                  <h5>Quotation Details</h5>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      {
                        !validateFlag?.requote ?
                          <h6>
                            {validator.current.message(
                              "Service Type",
                              selectedValue,
                              "required",
                              {
                                className:
                                  "text-white bg-danger p-1 text-center text-capitalize",
                              }
                            )}
                          </h6> : ""
                      }
                      <TableService
                        serviceType={serviceObj}
                        serviceHandler={deliveryHandler}
                        selected={selectedValue}
                      // setQuotedData={setQuotedData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* {
            isAddOnsShow ?

              : null
          } */}
          <EnquiryAddOns
            detaildata={quotationData.request_data}
            DestinationValue={DestinationValue}
            OrginValue={OrginValue}
            setStorageValue={setStorageValue}
            storageValue={storageValue}
            selectedValue={selectedValue}
            deliverytotal={deliverytotal}
            deliveryInitial={deliveryInitial}
            setInsuranceValue={setInsuranceValue}
            insuranceValue={insuranceValue}
            quotedData={deliveryInitial}
            setFinalFreightAmount={setFinalFreightAmount}
            setTotalpackingCharge={setTotalpackingCharge}
            setPackingChargeAmount={setPackingChargeAmount}
            setPackingJson={setPackingJson}
            setFreightCharge={setFreightCharge}
            setSpinner={setSpinner}
            discount={discountAmount}
            percentage={percentageValue}
            settingDiscount={setDiscountAmount}
            setSubTotalInit={setSubTotalInit}
            itemGoods={goodValue}
            userFreight={userFreight}
            getDetail={getDetailsData}
            setPackingwithService={setPackingwithService}
            packingwithService={packingwithService}
            insuranceData={insuranceData}
            packingJson={packingJson}
          />

          {/* <div className="tab-pane fade show" id="enquiryInfo" role="tabpanel">
            


            </div> */}

          <DetailEnquiry
            quoteNumber={getDetailsData?.quote_token}
            finalAmount={finalFreightAmount}
            deliverytotal={deliveryInitial}
            setFollowup={setFollowupdate}
            followUp={followUpdate}
            setConfirm={setConfirmedthis}
            confirm={confirmedThis}
            validator={validator}
            packingcharge={packingChargeAmount}
            insurance={insuranceValue}
            storage={storageValue}
            discount={discountAmount}
            validateFlag={validateFlag}
            percentValue={percentageValue}
            subTotalInit={subTotalInit}
          />
        </div>

        <div className="card-body">
          <div className="mt-3 row">
            <div className="col-6">
              <button
                className="btn btn-danger w-sm waves-effect waves-light"
                type="button"
                onClick={() => history.goBack()}
              >
                Back
              </button>
            </div>

            <div className="col-6 text-end">
              <button
                className="btn btn-primary w-sm waves-effect waves-light me-3"
                type="button"
                onClick={() => saveQuoteHandler("confirmed")}
              // onClick={() => proceedAddtojobHandler()}
              >
                Confirmed Job
              </button>

              {confirmedThis == "NO" ? (
                <button
                  className="btn btn-danger w-sm waves-effect waves-light me-3"
                  type="button"
                  onClick={() => setOpenModal(getDetailsData?.quote_token)}
                >
                  Delete Enquiry
                </button>
              ) : (
                <button
                  className="btn btn-primary w-sm waves-effect waves-light me-3"
                  type="button"
                  onClick={() => saveQuoteHandler("savetofollow")}
                >
                  Save Enquiry
                </button>
              )}

              <button
                className="btn btn-success w-sm waves-effect waves-light"
                type="button"
                onClick={() => reQuote()}
              >
                Re-Quote
              </button>
            </div>
          </div>
        </div>



      </div>

      {spinner && (
        <div className="loading_spin text-center bg-transparent">
          <div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {Boolean(openModal) && (
        <DeleteItem
          isOpen={Boolean(openModal)}
          title="Delete Enquiry"
          message={`Are you sure want to delete?`}
          onSubmitEvent={() => onModalSubmit()}
          handleClose={() => setOpenModal(false)}
        />
      )}

      <Loader
        isShow={
          loader.air_loader &&
          loader.sea_loader &&
          loader.courier_loader &&
          loader.land_loader
        }
      />
    </div>


  );
};
